import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "../../Policy detail page bike/policySteps.css";
import { NavbarJourney } from "../../Navbar/NavbarJourney";
import { Form, Button } from "antd/lib";
import { EditOutlined, CheckOutlined } from "@ant-design/icons";
import { CustomerDetails } from "../../../Redux/actions/NumBikeation";
import moment from "moment";
import CustomerdisplayNew from "./NewCustDisplay";
import { Prop1side } from "./PropSideBox";
import { KycVerifyNewVeh } from "./KycVerify";
import { OwnerProposal1 } from "./PropOwnerInfo";
import { Proposal2 } from "../../proposols/step2/prop2body";
import { VehicleProposal4 } from "./PropVehicleInfo";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
import { set_info1 } from "../../../Redux/action";

const CustomerInfoNew = () => {
  const CustDetail = useSelector((state) => state?.common?.customerDetail);
  const Bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const QuickQuotePost = useSelector(
    (state) => state?.vehicledetail?.quickQuotePost
  );
  const QuickQuoteInput = useSelector(
    (state) => state?.vehicledetail?.quoteInput
  );
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );
  const AddressInfo = useSelector((state) => state?.addressdetail?.info1);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);

  const [form] = Form.useForm();
  const Ref = useRef(null);
  const Ref2 = useRef(null);
  const Ref3 = useRef(null);
  const Ref4 = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [Age, setAge] = useState("");
  const [dob, setDob] = useState("");
  const [showCkyc, setShowCyc] = useState(false);
  const [showAadhaar, setShowAadhar] = useState(false);
  const [showStep1, setShowStep1] = useState(false);
  const [showStep2, setShowStep2] = useState(false);
  const [showStep3, setShowStep3] = useState(false);
  const [showStep4, setShowStep4] = useState(false);
  const [showStep5, setShowStep5] = useState(false);
  const [kycNumvalue, setkycNum] = useState("No");
  const [iciciKycSuccess, setIciciKycSuccess] = useState("");
  const [iciciKycError, setIciciKycError] = useState("");
  const [ckycDocId, setckycDocId] = useState(
    CustDetail?.ckycReferenceDocId ? CustDetail?.ckycReferenceDocId : "D07"
  );
  const [CkycType, setCkycType] = useState(
    CustDetail?.ckyc_type ? CustDetail?.ckyc_type : "PAN"
  );

  // const [docId, setDocId] = useState('');
  useEffect(() => {
    if (CkycType === "AADHAAR") {
      setShowAadhar(true);
    }
  }, [CkycType]);
  // console.log("showStep40", showStep5);
  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };
  const onChange = (e) => {
    // console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const handleInputChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ PAN_Number: e.target.value });
  };
  const calculateAge = (date) => {
    // console.log(date);

    const dateString = moment(date).format("YYYY-MM-DD");
    // console.log(dateString);

    setDob(dateString);
    const dobObject = new Date(date); // Convert the date string to a Date object
    // console.log(dobObject);
    const ageDifMs = Date.now() - dobObject.getTime(); // Get the difference in milliseconds
    // console.log(ageDifMs);

    const ageDate = new Date(ageDifMs); // Create a new date object using the difference
    // console.log(ageDate);

    const ageInYears = Math.abs(ageDate.getUTCFullYear() - 1970).toString();
    // console.log(ageInYears);
    if (ageInYears === "53") {
      setAge("");
    } else {
      setAge(ageInYears);
    }
    // console.log(Age);
  };
  const disabledDate = (current) => {
    const today = moment();
    const minDate = today.subtract(18, "years");

    return current.isAfter(minDate, "day");
  };
  const getDefaultPickerValue = () => {
    const today = moment();
    const minDate = today.subtract(18, "years");
    return minDate;
  };
  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    form.scrollToField(errorInfo.errorFields[0].name);
  };
  const customerEdit = () => {
    setShowStep1(false);
    setShowStep2(false);
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditOwner = () => {
    setShowStep2(false);
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditNominee = () => {
    setShowStep3(false);
    setShowStep4(false);
    setShowStep5(false);
  };
  const customerEditVehicle = () => {
    setShowStep4(false);
    setShowStep5(false);
  };
  const handleAadhaarNumberChange = (e) => {
    const inputValue = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    const truncatedValue = inputValue.slice(0, 12);
    const formattedValue = truncatedValue.replace(/^[01]/, "");
    const finalValue = formattedValue.replace(/(\d{4})(?=\d)/g, "$1 ");
    e.target.value = finalValue;
    form.setFieldsValue({ aadhaar_number: finalValue });
  };
  const handleGSTChange = (e) => {
    e.target.value = e.target.value.toUpperCase();
    form.setFieldsValue({ gst_number: e.target.value });
  };
  // console.log(ckycDocId);
  const onFinish = (data) => {
    // console.log("data", data);
    data.DateOfBirth = moment(data?.DateOfBirth).format("YYYY-MM-DD");
    data.ckyc_type = CkycType;
    data.ckycReferenceDocId = ckycDocId;
    switch (ckycDocId) {
      case "D03":
        data.ckycReferenceNumber = data?.aadhaar_number;
        break;
      case "D07":
        data.ckycReferenceNumber = data?.PAN_Number;
        break;
      case "D02":
        data.ckycReferenceNumber = data?.ckyc_number;
        break;
      default:
    }
    setLoading(true);
    // console.log(data);
    dispatch(CustomerDetails(data));
    if (SelectedQQ?.provider !== "icici") {
      const timeoutId = setTimeout(() => {
        setLoading(false);
        setShowStep1(true);
        Ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  };

  const onChangeCkycType = (e) => {
    //console.log(e);
    setCkycType(e);
    if (e === "AADHAAR") {
      setShowAadhar(true);
      setckycDocId("D03");
    } else if (e === "PAN") {
      setShowAadhar(false);
      setckycDocId("D07");
    }
  };
  const OnckycChange = (e) => {
    setkycNum(e.target.value);
    // console.log("radio checked", e.target.value);
    if (e.target.value === "Yes") {
      setShowCyc(true);
      setShowAadhar(false);
      setckycDocId("D02");
    } else if (e.target.value === "No") {
      setShowCyc(false);
      setShowAadhar(true);
      switch (CkycType) {
        case "AADHAAR NUMBER":
          setckycDocId("D03");
          break;
        case "PAN NUMBER":
          setckycDocId("D07");
          break;
        default:
          setckycDocId("");
          break;
      }
    }
  };
  const handleKYCiCICI = (values) => {
    console.log("handleKYCiCICI", values);
    console.log("CkycType", CkycType);
    setLoading(true);
    setShowStep1(false);
    let aadhaarNumber = values?.aadhaar_number;
    aadhaarNumber = aadhaarNumber?.replace(/\s/g, "");
    //console.log(aadhaarNumber);

    let post = {
      insurance_id: Bikenum?.bike_insurance_id,
      pan_card_number: values?.PAN_Number,
      dob: moment(values?.DateOfBirth).format("DD-MM-YYYY"),
      type: CkycType,
      //
      aadhaar_number: aadhaarNumber,
      full_name: values?.AadhaarName,
      gender: values?.gender === "male" ? "M" : "F",
    };
    axiosInstance
      .post(
        `v1/bike_insurance/insurers/${SelectedQQ?.provider}/kyc_status`,
        post
      )
      .then((res) => {
        // console.log(res)
        if (res?.data?.statusMessage === "Success") {
          let KYC = res?.data?.kyc_details;
          var data = {
            Owner: KYC?.first_name,
            Mobile: KYC?.mobile_number,
            Email: KYC?.email,
            Address: KYC?.permanent_address?.address_line_1,
            CkycNumber: KYC?.ckyc_number,
            City: KYC?.permanent_address?.city,
            il_kyc_ref_no: KYC?.il_kyc_ref_no,
            Pincode: KYC?.permanent_address?.pin_code,
          };
          dispatch(set_info1(data));
          setLoading(false);
          setIciciKycError("");
          setIciciKycSuccess("KYC Verified Successfully");
          setTimeout(() => {
            setShowStep1(true);
            Ref.current?.scrollIntoView({ behavior: "smooth" });
          }, 1000);
        } else {
          setLoading(false);
          setShowStep1(false);
          setIciciKycError(res?.data?.message);
          setIciciKycSuccess("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleReview = () => {
    setLoading(true);
    const post = {
      vehicle_core_code: BikeMakeData?.VehicleCoreCode,
      rto_code: BikeMakeData?.selected_rto,
      first_name: AddressInfo?.Owner,
      address_line_1: AddressInfo?.Address,
      address_line_2: AddressInfo?.Address,
      address_line_3: AddressInfo?.City,
      address_line_5: AddressInfo?.State,
      pincode: AddressInfo?.Pincode,
      email: AddressInfo?.Email,
      mobile: AddressInfo?.Mobile,
      date_of_birth: CustDetail?.DateOfBirth,
      title: "Mrs",
    };
    // /bike_insurances/new/:insurance_id/insurers/:insurer/proposal
    axiosInstance
      .post(
        `bike_insurances/new/${Bikenum?.insurance?.id}/insurers/${SelectedQQ?.insurer}/proposal`,
        post
      )
      .then((res) => {
        console.log(res?.data);
        setTimeout(() => {
          setLoading(false);
          history.push("/verify-payment");
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <>
      <NavbarJourney />
      <div className="row py-3">
        <div className="col-xl-3 col-lg-12 col-md-12 col-sm-12">
          <Prop1side />
        </div>
        <div className="col-xl-9 col-lg-12 col-md-12 col-sm-12">
          <div className="container d-flex justify-content-center flex-column">
            <div>
              <div
                className="step1-header-skb custdetail"
                style={{ marginBottom: "0px" }}
                ref={Ref}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Know Your Customer
                </h4>
                {showStep1 ? <EditOutlined onClick={customerEdit} /> : null}
              </div>
              <p style={{ margin: "10px 0px" }}>
                <span style={{ color: "red", marginRight: "5px" }}>*</span>
                To Complete the purchase, we need the following customer
                details.
              </p>
              {showStep1 ? (
                <CustomerdisplayNew />
              ) : (
                <KycVerifyNewVeh
                  showStep1={showStep1}
                  setShowStep1={setShowStep1}
                  Ref={Ref}
                />
              )}
            </div>
            <div className="step2" style={{ marginTop: "30px" }}>
              <div
                className={showStep1 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Owner Information
                </h4>
                {showStep2 ? (
                  <EditOutlined onClick={customerEditOwner} />
                ) : null}
              </div>
              {showStep1 ? (
                <OwnerProposal1
                  setShowStep2={setShowStep2}
                  showStep2={showStep2}
                  Ref2={Ref2}
                />
              ) : null}
            </div>
            <div className="step2">
              <div
                className={showStep2 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref2}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Nominee Details
                </h4>
                {showStep3 ? (
                  <EditOutlined onClick={customerEditNominee} />
                ) : null}
              </div>
              {showStep2 ? (
                <Proposal2
                  setShowStep3={setShowStep3}
                  showStep3={showStep3}
                  Ref3={Ref3}
                />
              ) : null}
            </div>
            <div className="step2">
              <div
                className={showStep3 ? `step1-header-skb custdetail` : null}
                style={{ marginBottom: "0px" }}
                ref={Ref3}
              >
                <h4 className="mb-0" style={{ fontSize: "19px" }}>
                  Vehicle Information
                </h4>
                {showStep4 ? (
                  <EditOutlined onClick={customerEditVehicle} />
                ) : null}
              </div>
              {showStep3 ? (
                <VehicleProposal4
                  setShowStep4={setShowStep4}
                  showStep4={showStep4}
                  // setShowStep5={setShowStep5}
                  // showStep5={showStep5}
                  Ref4={Ref4}
                />
              ) : null}
            </div>
            {/* {QuickQuoteInput?.insuranceProductCode === "Not_Secure" ? null : (
              <div className="step2">
                <div
                  className={showStep5 ? `step1-header-skb custdetail` : null}
                  style={{ marginBottom: "0px" }}
                  ref={Ref4}
                >
                  <h4 className="mb-0" style={{ fontSize: "19px" }}>
                    Previous Policy Information
                  </h4>
                </div>
                {showStep5 ? (
                  <PreviousPolicyDetails
                    setShowStep4={setShowStep4}
                    showStep4={showStep4}
                  />
                ) : null}
              </div>
            )} */}
            <>
              {showStep4 ? (
                <div className="btnreviewsub">
                  <Button
                    loading={loading}
                    onClick={handleReview}
                    type="primary"
                    htmlType="submit"
                  >
                    Review & Submit
                  </Button>
                </div>
              ) : null}
            </>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerInfoNew;
